<template>
  <div>
      <StockCard :direction="'IN'" :types="types"></StockCard>
  </div>
</template>

<script>
import StockCard from './stockcard.vue'
export default {
  components: { StockCard },
  data(){
    return{
          types:[
                {
                    code:"GRN_PO",
                    name:"GRN_FROM_PO"
                },
                {
                    code:"GRN",
                    name:"GOOD_RECEIVE_NOTE"
                },
                {
                    code:"ADJUSTMENT",
                    name:"ADJUSTMENT"
                }
            ],
    }
  }
}
</script>